import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import {
  setIsDataFeching,
  setNotificationResp,
} from 'src/redux/app/messageAndNotificationSlice';

const useMessageAndNotification = (data) => {
  const dispatch = useDispatch();
  const { NotificationResp } = useSelector(
    (state) => state?.messageAndNotification,
  );

  useEffect(() => {
    let listData = [];
    let detailData = {};
    let readMessage = {};
    if (data?.filteredData?.length > 0 && data?.messageDetailData?.length > 0) {
      listData = data?.filteredData;
      detailData = data?.messageDetailData;
      readMessage = data?.filteredData?.filter(
        (item) => item.id === detailData[0]?.id,
      );
    } else if (
      data?.updateReminderListData?.length > 0 &&
      data?.updateReminderListData[data?.updateReminderDetailData]
    ) {
      listData = data?.updateReminderListData;
      detailData = data?.updateReminderDetailData;
      readMessage = data?.updateReminderListData?.filter(
        (item) =>
          item.id ===
          data?.updateReminderListData[data?.updateReminderDetailData]?.id,
      );
    }
    if (readMessage?.length > 0 && readMessage[0]?.id) {
      readMessage[0].isread = true;
      const readMessageMap = new Map(
        readMessage.map((obj) => [obj.id, obj.isread]),
      );

      const listSetterFunction = data?.setFilteredData
        ? data?.setFilteredData
        : data?.setUpdateReminderListData;

      const finalListData = listData?.map((obj) => ({
        ...obj,
        isread: readMessageMap.has(obj.id)
          ? readMessageMap.get(obj.id)
          : obj.isread,
      }));
      listSetterFunction([...finalListData]);
    }
  }, [
    //data?.messageDetailData,
    //data?.setFilteredData,
    //data?.updateReminderDetailData,
    //data?.setUpdateReminderListData,
    NotificationResp?.MessageCount?.Notification,
    NotificationResp?.MessageCount?.Message,
  ]);

  //Get Notification Count API handler to update notification count
  const updateNotificationCount = async () => {
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      const MessageDetails =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageDetail;
      if (MessageCounts && MessageDetails) {
        dispatch(
          setNotificationResp(
            responseNotification?.data?.Response?.ResponseObectForNotification,
          ),
        );
      }
      return 'success';
    } catch (error) {
      dispatch(setNotificationResp({}));
      return 0;
    } finally {
      dispatch(setIsDataFeching(false));
    }
  };

  return {
    updateNotificationCount,
  };
};

export default useMessageAndNotification;
